import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { createI18nStore } from 'svelte-i18next'
import en from './resources/en.json'
import fr from './resources/fr.json'
import { z } from 'zod'

i18next
  .use(LanguageDetector)
  .init({
    // Svelte escapes by default
    interpolation: { escapeValue: false },
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
  })

z.config(z.locales.en())
z.config(z.locales.fr())

const i18n = createI18nStore(i18next)
export default i18n
export { z }
